var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.706,
    height: 39.706,
    viewBox: "0 0 39.706 39.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M25.283,12.844a.736.736,0,1,1-.736-.736.736.736,0,0,1,.736.736Zm-.736,6.273a.736.736,0,1,0,.736.736A.736.736,0,0,0,24.547,19.117Zm15.158.736A19.853,19.853,0,1,1,19.853,0,19.875,19.875,0,0,1,39.706,19.853Zm-9.737,7.009a.62.62,0,0,0-.62-.62H17.428a1.976,1.976,0,0,0-3.753,0H10.357a.62.62,0,1,0,0,1.241h3.318a1.976,1.976,0,0,0,3.753,0h11.92a.62.62,0,0,0,.62-.62Zm0-7.009a.62.62,0,0,0-.62-.62H26.424a1.976,1.976,0,0,0-3.753,0H10.357a.62.62,0,1,0,0,1.241H22.671a1.976,1.976,0,0,0,3.753,0h2.925A.62.62,0,0,0,29.969,19.853Zm0-7.009a.62.62,0,0,0-.62-.62H26.424a1.976,1.976,0,0,0-3.753,0H10.357a.62.62,0,0,0,0,1.241H22.671a1.976,1.976,0,0,0,3.753,0h2.925A.62.62,0,0,0,29.969,12.844ZM15.552,26.125a.736.736,0,1,0,.736.736.736.736,0,0,0-.736-.736Z",
    fill: "#ef6f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.cf4fe5746ff3258bc89e5022693517c2.svg";
export { ForwardRef as ReactComponent };